import { DataType } from "../../../services/CompanyService";
import { unbreak } from "../../../utils/FormatUtils";

export class TableHeader {
  public label: () => JSX.Element;
  /**
   * true cuando la tabla que contiene este header adhiere al contrato de anchos
   * (ver `docs/ANCHO_COLUMNAS_TABLAS.md` y `tableWidthRegistry.ts`). Lo setea
   * quien construye los headers; las celdas lo leen para no volver a concatenar
   * clases de ancho legacy sobre `className`.
   *
   * Opcional a propósito: varias pantallas (ReportInvoice,
   * ReportInvoiceStatusList) arman headers como objeto literal y no por
   * constructor, así que como propiedad requerida rompe la compilación.
   */
  public widthContract?: boolean = false;
  constructor(
    public key: string,
    labelElement: string | (() => JSX.Element),
    public numeric: boolean = false,
    public sorteable: boolean = true,
    public className: string = "",
    public tooltip: string = ""
  ) {
    this.label =
      typeof labelElement === "string"
        ? () => <>{unbreak(labelElement)}</>
        : labelElement;
  }
}

export class TableHeaderWithFieldId extends TableHeader {
  constructor(
    key: string,
    labelElement: string | (() => JSX.Element),
    numeric: boolean = false,
    sorteable: boolean = true,
    public fieldId: string,
    public type: DataType,
    public className: string = "",
    public tooltip: string = ""
  ) {
    super(key, labelElement, numeric, sorteable, className);
  }
}
